import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { TicketListPageFilterSchema } from './-zod-schema';

// チケット 一覧（QA Force グローバルメニュー）。
// URL search のスキーマだけここで定義し、コンポーネントは development-tickets.lazy.tsx
// 側で createLazyFileRoute 経由で遅延ロードして bundle 分割する。
// （test-sets / values 等と同じパターン：DataTable / useReactTable の重い generic
//   推論を module 境界で trunk typecheck から分離 → cascade 回避）
export const Route = createFileRoute('/_stacktrace/development-tickets/')({
  validateSearch: zodValidator(TicketListPageFilterSchema),
});
